import { type DatadogMonitorRequestParams } from 'types/api/datadog/monitors'

export const monitorsQueryKeys = {
  datadog: ({
    datadogIntegrationName,
    domain,
    monitorId,
    teamId
  }: DatadogMonitorRequestParams & {
    monitorId: string
    teamId: string
  }) =>
    [
      `/datadog/monitors/${monitorId}`,
      { datadogIntegrationName, teamId, ...(domain && { domain }) }
    ] as const
}
